/**
 * Returns true of false if the user if one of the provided types
 * @param {*} user (object, required) - the user to check the type of, should have a "type" property of string type
 * @param  {...any} types (strings, required) - the type(s) to check, for now, the expected values are : "normal", "staff", "technical"\
 * Usage : `checkUserType(user, "staff")` returns true if user.type === "staff"\
 * `checkUserType(user, "staff", "technical")` <- returns true if user.type === "staff" OR if user.type === "technical"\
 */
// eslint-disable-next-line import/prefer-default-export
export function checkUserType(user, ...types) {
  if (!user) {
    return false
  }
  return types.find((type) => user.type === type) !== undefined
}
